import { render, staticRenderFns } from "./PlugInData.vue?vue&type=template&id=d098f26e&scoped=true"
import script from "./PlugInData.vue?vue&type=script&lang=js"
export * from "./PlugInData.vue?vue&type=script&lang=js"
import style0 from "./PlugInData.vue?vue&type=style&index=0&id=d098f26e&prod&scoped=true&lang=scss"
import style1 from "./PlugInData.vue?vue&type=style&index=1&id=d098f26e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d098f26e",
  null
  
)

export default component.exports